import { useState } from "react";

const QuoteCustomers = (
    {
        customers,
        setName,
        setPhone,
        setEmail,
        saveQuote,
        name
    }
) => {
    
    const [ value, setValue ] = useState(name);

    const handleChange = (event) => {
        setValue(event.target.value);
    };
    
    const onBlur = () => {
        if (customers.map(item=>`${item.name} - ${item.phone}`).includes(value)) {
            const customer = customers.find(item => `${item.name} - ${item.phone}` === value);
            setName(customer.name);
            setPhone(customer.phone);
            setEmail(customer.email);
            saveQuote({
                name:customer.name,
                phone:customer.phone,
                email:customer.email
            });
            setValue(customer.name);
        }
        else {
            saveQuote({name:value});
        }
    };
    
    const handleKey = (event) => {
        if (event.key === 'Enter' || event.key === 'Escape') event.target.blur();
    };

    return (
        <>
            <div
                className='QuoteText'
            >
                <input
                    list="customers"
                    type="text"
                    value={value}
                    onChange={handleChange}
                    placeholder={"Client"}
                    onBlur={onBlur}
                    onKeyDown={handleKey}
                />
            </div>
            {   
                true
                &&  
                <datalist id="customers">
                    {customers.map((item) => (
                        <option key={`${item.name} - ${item.phone}`} value={`${item.name} - ${item.phone}`}/>
                    ))}
                </datalist>
            }
        </>
    );
};

export default QuoteCustomers;